import { useTranslation } from "react-i18next";

// Colors keep at least 4.5:1 contrast with the white text.
const LABELS = {
  popular: "bg-[var(--brand-color)]",
  "best-choice": "bg-[#080a0f]",
  basic: "bg-[#626468]",
  // A feature rather than a rank like the others, so a softer, grayer blue
  // than Popular's.
  "sim-card": "bg-[#3e738e]",
};

export default function ProductLabel({ label, className = "" }) {
  const { t } = useTranslation();
  if (!LABELS[label]) return null;

  return (
    <span
      className={`inline-block whitespace-nowrap rounded px-2 py-0.5 text-sm font-semibold leading-snug text-white ${LABELS[label]} ${className}`}
    >
      {t(`labels.${label}`)}
    </span>
  );
}
